export default __webpack_public_path__ + "static/media/logo.85d07ca9.svg";